import IMask from "imask";
import {Controller} from '@hotwired/stimulus';
import {addCustomValidation} from "@trf4/ui-utils";
import validarCNPJ from "../validarCNPJ";

/**
 * Stimulus Controller para InputCnpj
 *
 * Aplica máscara de CNPJ (00.000.000/0000-00) dinamicamente e valida os caracteres digitados.
 */
export default class extends Controller {
    static targets = ['input'];

    connect() {
        this.inputElement = this.element.querySelector('input') || this.element;
        const id = this.inputElement.id
        const maskOptions = {
            mask: 'XX.XXX.XXX/XXXX-00',
            definitions: {
                'X': /[a-zA-Z0-9]/
            },
            prepare: str => str.toUpperCase(),
        };
        IMask(this.inputElement, maskOptions);

        addCustomValidation(id, 'input', function (val) {
            return validarCNPJ(val) ? true : 'CNPJ inválido';
        });
    }

    disconnect() {
        // ??
    }
}
